import { makeSvgImage } from '../../../../../../components/SvgImage/index.ts';

export const Mountains = makeSvgImage(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 194 8">
    <path
      fill="#647693"
      d="M194 8s-25.33-3.98-37-5c-4.31-.37-6.96 1.73-12.07 2.6-7.83 1.31-13.44 2.36-21.96 2.4h-.4C105.5 7.93 93.98-1.55 72.2.22 64.7.83 62 2.02 55.1 3 35.1 5.86 0 8 0 8h194Z"
    />
  </svg>,
);
